// Build-time flags (envs/<env>.env). EXPO_PUBLIC_* values are inlined into the
// bundle at build time, so these are fixed per-deployment, not runtime toggles.

// Email/password login: a dev-only convenience while SSO isn't confirmed
// working everywhere yet. Unset/anything but "true" hides it — see login
// screen (the email/password form + button) and account settings (the
// change-password action, which has nothing to reset when password login
// itself is off).
export const PASSWORD_LOGIN_ENABLED =
  process.env.EXPO_PUBLIC_ENABLE_PASSWORD_LOGIN === "true";

// Chatbot widget button on the wiki screen. Enabled by default (dev);
// production explicitly opts out while the prod agent isn't ready for
// general use — see EXPO_PUBLIC_ENABLE_CHATBOT in envs/production.env.
export const CHATBOT_ENABLED =
  process.env.EXPO_PUBLIC_ENABLE_CHATBOT !== "false";
